module.exports = __webpack_public_path__ + "static/media/text_icon_inside_rectangle.a6470a1e.svg";